import * as ContextMenuActions from "../actions/ContextMenu.Actions";

export interface IContextMenuState {
  menus: Map<string, IContextMenu>;
}

interface IContextMenu {
  isOpen: boolean;
}

const initialState: IContextMenuState = {
  menus: new Map<string, IContextMenu>(),
};

export const ContextMenuReducer = (
  state: IContextMenuState = initialState,
  action: ContextMenuActions.Action
): IContextMenuState => {
  let contextMenu: IContextMenu;
  switch (action.type) {
    case ContextMenuActions.Type.OPEN_CONTEXT_MENU:
      contextMenu = state.menus.get(action.mosaicId) ?? { isOpen: true };
      return {
        ...state,
        menus: new Map<string, IContextMenu>(state.menus).set(action.mosaicId, {
          ...contextMenu,
          isOpen: true,
        }),
      };
    case ContextMenuActions.Type.CLOSE_CONTEXT_MENU:
      contextMenu = state.menus.get(action.mosaicId) ?? { isOpen: false };
      return {
        ...state,
        menus: new Map<string, IContextMenu>(state.menus).set(action.mosaicId, {
          ...contextMenu,
          isOpen: false,
        }),
      };
    default:
      return state;
  }
};
